<main class="main">
  <section class="wrap-title"
    style="background: url('https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/Vistoria_1920x324-1.png'); background-size: cover;">
    <div class="layout">
      <h1 class="title-page">Curso de Vistoria Cautelar</h1>
    </div>
  </section>

  <section class="wrap-content">
    <div class="layout">
      <div class="content">
        <div class="left">
          <h2 class="section-title">Capacitação com foco técnico e aplicação prática</h2>
          <div class="ckeditor">
            <p>
              A Universidade do Carro é parceira da Union Solutions na capacitação profissional em vistoria veicular.
              O curso livre foi estruturado para inspetores, ECVs, seguradoras, locadoras e frotistas.
            </p>
            <p>
              A trilha combina simulações de campo, avaliação objetiva por rubrica e certificação digital com QR Code
              verificável, apoiando a padronização técnica das operações.
            </p>
          </div>
          <div class="highlights">
            <span>Simulações realistas</span>
            <span>Avaliação objetiva</span>
            <span>Certificação com QR Code</span>
          </div>
          <div class="button">
            <a class="btn gradient" [href]="heroCtaHref" target="_blank" rel="noopener" (click)="trackCta('hero')">
              Acessar Universidade do Carro
            </a>
            <a class="btn outline" [href]="whatsappHref" target="_blank" rel="noopener" (click)="trackWhatsApp('hero')">
              Falar no WhatsApp
            </a>
          </div>
          <p class="disclaimer">
            Curso livre de capacitação. Não confere habilitação de Empresa Credenciada de Vistoria (ECV). Para vistoria
            de identificação veicular, aplicam-se os requisitos da Resolução CONTRAN nº 941/2022.
          </p>
        </div>
        <div class="right">
          <figure class="fig">
            <img src="assets/images/universidade-do-carro.jpg" alt="Curso de vistoria veicular da Universidade do Carro">
          </figure>
        </div>
      </div>
    </div>
  </section>

  <section class="wrap-steps">
    <div class="layout">
      <h2 class="steps-title">Passo a passo para iniciar</h2>
      <div class="steps-grid">
        <article class="step-card">
          <span class="step-number">1</span>
          <h3>Acesse a Universidade do Carro</h3>
          <p>Entre no portal oficial pelo link da parceria com a Union Solutions.</p>
        </article>
        <article class="step-card">
          <span class="step-number">2</span>
          <h3>Cadastre-se</h3>
          <p>Crie sua conta com os dados necessários para liberar o acesso ao ambiente do aluno.</p>
        </article>
        <article class="step-card">
          <span class="step-number">3</span>
          <h3>Realize o pagamento</h3>
          <p>Escolha a forma de pagamento disponível na plataforma para iniciar a trilha.</p>
        </article>
        <article class="step-card">
          <span class="step-number">4</span>
          <h3>Faça o curso</h3>
          <p>Conclua os módulos com simulações práticas e avaliação objetiva por rubrica.</p>
        </article>
        <article class="step-card">
          <span class="step-number">5</span>
          <h3>Obtenha certificação</h3>
          <p>Finalize a trilha e emita seu certificado digital com QR Code verificável.</p>
        </article>
      </div>
      <div class="steps-cta">
        <a class="btn gradient" [href]="heroCtaHref" target="_blank" rel="noopener" (click)="trackCta('faq_cta')">
          Quero iniciar agora
        </a>
      </div>
    </div>
  </section>

  <app-contact-box></app-contact-box>
</main>
